/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {Project, ProjectFromJSON, ProjectToJSON,} from './Project';

/**
 *
 * @export
 * @interface ProjectApiResult
 */
export interface ProjectApiResult {
    /**
     *
     * @type {boolean}
     * @memberof ProjectApiResult
     */
    success?: boolean;
    /**
     *
     * @type {Project}
     * @memberof ProjectApiResult
     */
    content?: Project;
    /**
     *
     * @type {string}
     * @memberof ProjectApiResult
     */
    message?: string | null;
}

export function ProjectApiResultFromJSON(json: any): ProjectApiResult {
    return ProjectApiResultFromJSONTyped(json, false);
}

export function ProjectApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : ProjectFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ProjectApiResultToJSON(value?: ProjectApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': ProjectToJSON(value.content),
        'message': value.message,
    };
}

